import { ref } from 'vue'
import { accept, convertUploadFile } from './convertFile'
import LogoPdf from '@ezio/assets/images/logo-pdf.png'

let instance: any = null

export type FileUploadBoxOptions = {
    multiple?: boolean
}

const createInstance = () => {
    const current = ref(0)
    const visible = ref(false)
    const preview = ref<string>(null)
    const multiple = ref(false)
    const uploaded = ref(0)

    let onSelectCallback: (file: string, filename?: string) => unknown = null

    const show = async (callback: (file: string, filename?: string) => unknown, options: FileUploadBoxOptions = {}) => {
        visible.value = true
        preview.value = null
        multiple.value = !!options.multiple
        uploaded.value = 0
        onSelectCallback = callback
    }

    const dismiss = () => {
        visible.value = false
        onSelectCallback(null)
    }

    const onSelectFile = async (file: any) => {
        if (!file) return

        const { preview: previewValue } = await convertUploadFile(file, onSelectCallback)
        preview.value = previewValue ?? LogoPdf

        if (multiple.value) {
            uploaded.value++
            preview.value = null
        } else {
            visible.value = false
        }
    }

    return {
        accept,
        preview,
        current,
        visible,
        multiple,
        uploaded,
        onSelectFile,
        show,
        dismiss
    }
}

export const useFileUploadBox = () => {
    if (instance) {
        return {
            fileUploadBox: instance
        }
    }
    instance = createInstance()
    return {
        fileUploadBox: instance
    }
}
